import { useEffect, useState } from "react";
import Divider from "./Divider";
import '../scss/AppComponent.scss';
import { Label } from "evergreen-ui";



export function AuthPage({ children, title, description, icon }) {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  
    useEffect(() => {
      const handleResize = () => setWindowWidth(window.innerWidth);
  
      window.addEventListener("resize", handleResize);
  
      return () => window.removeEventListener("resize", handleResize);
    }, []);
  
    return (
      <div style={{ height: '100vh' }}>
        {windowWidth < 768 ? ( 
        <div className="auth-mobile-page">
          <div
            className='auth-mobile-page-card'>
              <div className='auth-mobile-page-left'>{children}</div>
  
          </div>
          <div className='flex' style={{ textAlign: 'center', paddingTop: 10, color: 'black', paddingBottom: 15 }}>
            <span>
              © 2024,
              <a href='https://orkaapps.com/' target='_blank' style={{ textDecoration: 'none', color: 'black', width: '100px' }}>Orkaapps Shopping Website.</a>
              <br/>
              All Rights Reserved.
            </span>
          </div>
        </div>
        ):(
          <div className="auth-page">
          <div
            className='auth-page-card'>
              <div className='auth-page-left'>{children}</div>
            <><Divider type="vertical" margin={0} /><div className='auth-page-right'>
                <img src={icon} alt='' style={{ paddingBottom: 10, width: '330px', alignSelf: 'center' }} />
                <Label fontSize={24} fontWeight={400} paddingTop={15} paddingBottom={5} lineHeight={2.5}>{title}</Label>
                <Label fontSize={18} lineHeight={2.5} fontWeight={300}>{description}</Label>
              </div></>
  
          </div>
          <div className='flex' style={{ textAlign: 'center', paddingTop: 50, color: 'black', paddingBottom: 15 }}>
            <span>
              © 2024,
              <a href='https://orkaapps.com/' target='_blank' style={{ textDecoration: 'none', color: 'black' }}>Orkaapps Shopping Website.</a>
              All Rights Reserved.
            </span>
          </div>
        </div>
        )}
      </div>
    );
  }